import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { ToCheckerWrapper } from "./toChecker.style";
import TitleWrapper from "../../TitleWrap/TitleWrap";
import { Popconfirm, message } from "antd";
import Scanner from "../../BarcodeScanner/Scanner";
import { Button } from "@material-ui/core";
// import Quagga from "quagga";
import {
  decodeString,
  fetchToDetailsForChecker,
  holdToApiCall,
  isAllBoxesScanned,
} from "./helper/helper";
import {
  ALL_BOXES_CHECKED,
  BOX_DOES_NOT_EXIST_TO,
  BOX_SCANNED_ALREADY,
  INVALID_TO,
  REDIRECT_MESSAGE,
  SOMETHING_WENT_WRONG,
} from "../../../constants";
import { Base64func } from "../../Base64Func/Base64func";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ToBoxChecker = (props) => {
  const [showScanner, setShowScanner] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [boxes, setBoxes] = useState([]);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const history = useHistory();
  const {
    access_token,
    match: {
      params: { TOID },
    },
  } = props;
  const decodedStringTO = decodeString(TOID);
  if (!decodedStringTO.length) {
    message.error(INVALID_TO);
    props.history.push("/to-checker");
  }
  const toNumber = decodedStringTO.split("-")[0];
  const boxNumber = decodedStringTO.split("-")[1];
  const getData = (toNumber, boxNumber) => {
    if (!access_token) {
      message.error(REDIRECT_MESSAGE);
      history.push("/");
      return;
    }
    fetchToDetailsForChecker({ boxNumber, toNumber, access_token })
      .then((res) => {
        if (res.data.statusCode === 200) {
          const boxData = res.data.responseData.boxDetails.map((item) => {
            return item.boxNumber === boxNumber
              ? { ...item, isChecked: true }
              : item;
          });
          setBoxes(boxData);
          allVerified(boxData);
        } else {
          message.error(res.data.message);
          props.history.push("/to-checker");
        }
      })
      .catch((err) => {
        message.error(err.message || SOMETHING_WENT_WRONG);
      });
  };

  useEffect(() => {
    getData(toNumber, boxNumber);
  }, []);
  const allVerified = (temp) => {
    const allBoxVerified = temp.every((item) => item.isChecked);
    if (allBoxVerified) {
      setAllChecked(allBoxVerified);
      setEnableSubmit(true);
      message.success(ALL_BOXES_CHECKED);
    } else {
      reOpenCamera();
    }
  };
  const reOpenCamera = () => {
    if (!allChecked) {
      setTimeout(() => {
        openScanner();
      }, 0);
    }
  };
  const openScanner = () => {
    setShowScanner(true);
  };
  const closeScanner = () => {
    // showScanner && Quagga.stop();
    setShowScanner(false);
  };
  const checker = (id) => {
    const boxExists = boxes.find((box) => box.boxNumber === id) || false;
    if (boxExists && !boxExists.isChecked) {
      const temp = boxes.map((item) => {
        if (item.boxNumber === id) {
          return { ...item, isChecked: true };
        }
        return item;
      });
      setBoxes(temp);
      allVerified(temp);
      closeScanner();
    } else if (boxExists.isChecked) {
      message.error(BOX_SCANNED_ALREADY);
    } else {
      message.error(BOX_DOES_NOT_EXIST_TO);
    }
  };
  const onHold = () => {
    const checkedBoxes = boxes
      .filter((item) => item.isChecked)
      .map((item) => item.boxNumber);
    holdToApiCall({ access_token, toNumber, checkedBoxes })
      .then((res) => {
        if (res.data.statusCode === 200) {
          message.success(res.data.message);
          props.history.push("/to-checker");
        } else {
          throw new Error(res.data.message);
        }
      })
      .catch((err) => {
        message.error(err.message || SOMETHING_WENT_WRONG);
      });
  };
  const onSubmit = () => {
    isAllBoxesScanned({ access_token, toNumber: toNumber })
      .then((res) => {
        if (res.data.statusCode === 200) {
          message.success(res.data.message);
          props.history.push(
            "/to-checker-box-process/" + Base64func(toNumber, "encode")
          );
          // Quagga?.offDetected();
          // Quagga?.stop();
        } else {
          throw new Error(res.data.message);
        }
      })
      .catch((err) => {
        message.error(err.message || SOMETHING_WENT_WRONG);
      });
  };
  return (
    <ToCheckerWrapper className="centerScreen">
      <TitleWrapper title={`TO Number : ${toNumber}`} />
      <div className="boxesWraper">
        {boxes.map((item) => {
          return (
            <div
              className={["box", item.isChecked ? "checked" : "pending"].join(
                " "
              )}
            >
              <div className="label">Box ID :</div>
              <span>{item.boxNumber}</span>
            </div>
          );
        })}
      </div>
      {showScanner && !enableSubmit ? (
        <div className="scannerWrapper">
          <button className="bbtn" onClick={closeScanner}>
            Close Scanner
          </button>
          <Scanner onDetected={checker} />
        </div>
      ) : (
        <div>
          <Button
            disabled={enableSubmit}
            className="bbtn mb-25"
            onClick={openScanner}
          >
            Scan the box
          </Button>
          <Button
            disabled={!enableSubmit}
            className="bbtn mt-25"
            onClick={onSubmit}
          >
            Submit
          </Button>
          <Popconfirm
            title="Are you sure ?"
            onConfirm={onHold}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Button disabled={enableSubmit} className="bbtn mt-25">
              Hold
            </Button>
          </Popconfirm>
        </div>
      )}
    </ToCheckerWrapper>
  );
};

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pickerDetails: state.pickerorderReducer,
  newPickerDetails: state.newPickerOrderReducer,
  pdf: state.packageTrackerReducer,
  isOnline: state.statusReducer?.isOnline,
});
// export default ToPicker;
export default withRouter(connect(mapStateToProps, {})(ToBoxChecker));
